module.exports = Em.Handlebars.compile("{{#each}}\n    {{background-task task=this}}\n{{/each}}\n");